export default "__VITE_ASSET__BKn$Dc3J__"